<style lang="scss" scoped>
.col-form-label {
  font-weight: bold;
  text-align: right;
  padding-top: 0.1rem;
  font-size: 0.8rem;
}
</style>

<template>
  <label :for="cleanFor" class="col-sm-3 col-form-label">
    <slot></slot>
  </label>
</template>

<script>
export default {
  props: ["for"],
  computed: {
    cleanFor() {
      return this.for === null || this.for === undefined ? null : this.for;
    }
  }
};
</script>
